import {
    Box,
    Text,
    Title,
    Stack,
    ThemeIcon,
    Group
} from "@mantine/core";

import { IconShieldCheck } from "@tabler/icons-react";
import { IconCreditCard } from "@tabler/icons-react";
import { IconWallet } from "@tabler/icons-react";
// import Defaultlogo from '../../../Assets/Defaultlogo.png';

export default function AuthBranding() {
    return (
        <Box
            h={'100vh'}
            p={60}
            style={{
                background:
                    "linear-gradient(135deg,#4B0F87,#8B3DFF)",
                color: "white",
                display: "flex",
                alignItems: "center"
            }}
            
        >
            <Stack gap={40}>
                <div>
                    
                    <Title order={1} fw={800}>
                        PAYMENT PORTAL
                    </Title>

                    <Text mt="md" size="lg" opacity={0.9}>
                        Secure Digital Payments
                    </Text>
                </div>

                <Stack gap="xl">
                    <Group>
                        <ThemeIcon
                            radius="xl"
                            size={50}
                            color="white"
                            variant="light"
                        >
                            <IconShieldCheck size={24} />
                        </ThemeIcon>

                        <div>
                            <Text fw={600}>
                                Secure Transactions
                            </Text>

                            <Text size="sm" opacity={0.8}>
                                Enterprise grade security
                            </Text>
                        </div>
                    </Group>

                    <Group>
                        <ThemeIcon
                            radius="xl"
                            size={50}
                            color="white"
                            variant="light"
                        >
                            <IconWallet size={24} />
                        </ThemeIcon>

                        <div>
                            <Text fw={600}>
                                Wallet Management
                            </Text>

                            <Text size="sm" opacity={0.8}>
                                Real-time balance tracking
                            </Text>
                        </div>
                    </Group>

                    <Group>
                        <ThemeIcon
                            radius="xl"
                            size={50}
                            color="white"
                            variant="light"
                        >
                            <IconCreditCard size={24} />
                        </ThemeIcon>

                        <div>
                            <Text fw={600}>
                                Digital Services
                            </Text>

                            <Text size="sm" opacity={0.8}>
                                Recharge, BBPS, AEPS & More
                            </Text>
                        </div>
                    </Group>
                </Stack>
            </Stack>
        </Box>
    );
}